import { takeLatest } from 'redux-saga/effects'
import { ATTEMPT_LOGIN, ATTEMPT_REGISTER } from '../actions/types'
import { loginWorker, registerWorker } from './authSagas'

function* rootSaga() {
    yield takeLatest(ATTEMPT_LOGIN, loginWorker)
    yield takeLatest(ATTEMPT_REGISTER, registerWorker)
}

export default rootSaga